import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";
import { MRT_PaginationState } from "mantine-react-table";

export interface CollectionsListingResponse {
  data: CollectionsListing[];
  totalRowCount: number;
}

export interface CollectionsListing {
  id: string;
  accountId: string;
  collectionAccountId: string;
  currency: string;
  amount: number;
  amountOrigin: number;
  fee: number;
  status: string;
  creditedAt: string;
  rejectedAt: string;
  createdAt: string;
  paymentReference: string;
  paymentType: string;
  paymentDetails: string;
  reference: string;
  sender: Sender;
  receiver: Receiver;
}

interface Sender {
  name: String;
  accountNumber: string;
}

interface Receiver {
  accountHolderName: string;
  accountNumberType: string;
  bankName: string;
  accountNumber: string;
  paymentType: string;
}

interface GetCollectionsListingRequest {
  token: string;
  externalAccount: string;
  pagination: MRT_PaginationState;
  startDate?: string;
  endDate?: string;
}

const getCollectionsListing = async ({
  token,
  externalAccount,
  pagination,
  startDate,
  endDate,
}: GetCollectionsListingRequest): Promise<CollectionsListingResponse> => {
  try {
    const requestBody: any = {
      onBehalfOfAccount: externalAccount,
      pagination: {
        page: pagination.pageIndex + 1,
        perPage: pagination.pageSize,
      },
    };

    if (startDate) {
      requestBody.startDate = startDate;
    }

    if (endDate) {
      requestBody.endDate = endDate;
    }

    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/getCollectionsListing`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getCollectionsListing;
